import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppConfigService} from '../services/app-config.service';
import {VERSION} from '../../../environments/version';

@Injectable({
  providedIn: 'root'
})
export class VersionInterceptorService implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !req.url.startsWith(AppConfigService.apiUrl)
      && !req.url.startsWith(AppConfigService.taxManagerApiUrl)
      && !req.url.startsWith(AppConfigService.mobileApiUrl)
      && !req.url.startsWith(AppConfigService.messageStorageManagerApiUrl)
      && !req.url.startsWith(AppConfigService.changeLogsManagerUrl)
      && !req.url.startsWith(AppConfigService.notificationManagerUrl)
      && !req.url.startsWith(AppConfigService.eoApiUrl)
      // && !req.url.startsWith(AppConfigService.productMangementUrl)
    ) {
      let newParams = new HttpParams({fromString: req.params.toString()});
      newParams = newParams.append('v', VERSION.hash);

      return next.handle(req.clone({params: newParams}));
    }

    return next.handle(req);
  }
}
